/**
 * BirdBrain chart theme — single source of series colors and shared
 * Recharts styling. Colors resolve through the --chart-N CSS variables
 * (index.css), so light/dark and any future palette change are automatic.
 */

export const CHART_COLORS = [
  'hsl(var(--chart-1))',
  'hsl(var(--chart-2))',
  'hsl(var(--chart-3))',
  'hsl(var(--chart-4))',
  'hsl(var(--chart-5))',
  'hsl(var(--chart-6))',
] as const

export const seriesColor = (index: number): string => CHART_COLORS[index % CHART_COLORS.length]

/** Semantic aliases so call sites can say what they mean. */
export const SEMANTIC_COLORS = {
  brand: 'hsl(var(--chart-1))',
  info: 'hsl(var(--chart-2))',
  positive: 'hsl(var(--chart-3))',
  warning: 'hsl(var(--chart-4))',
  critical: 'hsl(var(--chart-5))',
  neutral: 'hsl(var(--muted-foreground))',
} as const

export const GRID_STROKE = 'hsl(var(--border))'
export const AXIS_TICK = {
  fill: 'hsl(var(--muted-foreground))',
  fontSize: 11,
} as const

export const AXIS_LINE = { stroke: 'hsl(var(--border))' } as const
